import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import Button from 'shared/button';

import { refreshLead } from 'bundles/project/actions/leads';

import EditContactModal from './edit_contact_modal';
import { showUpdateLeadModal } from '../../../actions';

export class EditContactLink extends React.Component {
  static propTypes = {
    lead: PropTypes.shape({
      id: PropTypes.number.isRequired,
      projectId: PropTypes.number.isRequired
    }).isRequired,
    onOpenBrokeTeamExpirienceLeadModal: PropTypes.func,
    onRefreshLead: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  state = {
    editing: false
  };

  handleCancel = () => {
    this.setState({ editing: false });
  }

  handleSave = () => {
    this.setState({ editing: false });
    this.props.onRefreshLead(this.props.lead);
  }

  startEdit = (e) => {
    this.props.onOpenBrokeTeamExpirienceLeadModal(this.props.lead);
  };

  render() {
    return (
      <React.Fragment>
        { this.renderNewLink() }
      </React.Fragment>
    );
  }

  renderNewLink() {
    return (
      <Button.Secondary className="ds-button--accent" name="edit-lead-button" outlined onClick={this.startEdit}>
        Edit Lead Info
      </Button.Secondary>
    );
  }

  renderEditModal() {
    const { lead } = this.props;

    return (
      <EditContactModal
        lead={lead}
        shown={this.state.editing}
        onCancel={this.handleCancel}
        onSave={this.handleSave}
      />
    );
  }
}

const mapDispatchToProps = {
  onRefreshLead: refreshLead,
  onOpenBrokeTeamExpirienceLeadModal: showUpdateLeadModal
};

export default connect(null, mapDispatchToProps)(EditContactLink);
